import React from 'react'
import { MagnifyingGlass, Receipt } from '@phosphor-icons/react'
import { DataTableEmptyState } from '../../components/table/DataTable'
import { DAILY_CONTROL_EMPTY_TEXT } from './constants/dailySettlementControlConstants'

export default function TableEmptyState({ noCharges }) {
  const Icon = noCharges ? Receipt : MagnifyingGlass
  const text = noCharges ? DAILY_CONTROL_EMPTY_TEXT.NO_CHARGES : DAILY_CONTROL_EMPTY_TEXT.NO_RESULTS
  return (
    <DataTableEmptyState
      icon={<Icon size={34} />}
      title={text.TITLE}
      description={text.DESCRIPTION}
    />
  )
}
